export const fontStyleDropdown = [
  { id: 1, name: "King Fahad Complex V1", value: "hafs1" },
  { id: 2, name: "King Fahad Complex V2", value: "hafs2" },
  { id: 3, name: "Uthmani Hafs", value: "uhfs" },
];
